import { HostingTypesWithCloudComplianceBoundaries, HostingTypeToQueryParam, Source } from '@atlassian/mpac-types';
import { AppTileHighlightedText } from '@atlassian/mpac-ui';
import { appListingLink, encodeAppName, getScaledImage } from '@atlassian/mpac-utils';
import React from 'react';
import { createTileHighlights } from '../../utils/createTileHighlights';
import { RegulatedSectorAppTilePreferredHosting } from './AppTile.types';
import { jsx as _jsx } from "react/jsx-runtime";
export const mpacHosting = hosting => {
  switch (hosting) {
    case 'cloud':
      return 'cloud';
    case 'server':
      return 'server';
    case 'dataCenter':
      return 'datacenter';
    default:
      {
        console.error('Invalid hosting provided : ' + hosting);
        return '';
      }
  }
};
export const resolveHosting = (tileData, preferredHosting) => {
  if (preferredHosting === RegulatedSectorAppTilePreferredHosting.GovernmentCloud) return HostingTypeToQueryParam[HostingTypesWithCloudComplianceBoundaries.GovernmentCloud];
  const {
    deployments
  } = tileData;
  if (preferredHosting && deployments.includes(preferredHosting)) {
    return mpacHosting(preferredHosting);
  }
  const priorityOrder = ['cloud', 'dataCenter', 'server'];
  const foundDeployment = priorityOrder.find(deployment => deployments.includes(deployment));
  return mpacHosting(foundDeployment) || 'cloud';
};
export const getAppListingUrl = (source, tileData, mountPath, preferredHosting) => {
  // In case of source as PRODUCT, mountPath can have values like '/jira/marketplace'.
  if (source === Source.PRODUCT) {
    return "".concat(mountPath, "/discover/app/").concat(tileData.addonKey);
  }
  const url = appListingLink('').expand({
    appId: tileData.addonId.toString(),
    slug: encodeAppName(tileData.name),
    hosting: resolveHosting(tileData, preferredHosting),
    tab: 'overview'
  });
  return url;
};

/**
 * Utility functions for AppTile components
 */

export const getAppLogoUrl = function getAppLogoUrl(tileData, options) {
  var _tileData$logo, _tileData$logo2;
  let isCompactView = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  const imageId = ((_tileData$logo = tileData.logo) === null || _tileData$logo === void 0 ? void 0 : _tileData$logo.highRes) || ((_tileData$logo2 = tileData.logo) === null || _tileData$logo2 === void 0 ? void 0 : _tileData$logo2.image);
  const {
    width,
    height
  } = tileData.logo || {};
  if (!imageId) return '';
  if (options.enableMediaFromProductListing) {
    const url = options.links.mediaFileProductListing.expand({
      imageId
    });
    if (options.enableScalingLogicOnUI) {
      if (isCompactView) {
        // For compact view, use fixed 32x32 size
        return "".concat(url, "?width=32&height=32");
      } else if (width && height) {
        // For regular view, use scaled dimensions
        const {
          width: scaledWidth,
          height: scaledHeight
        } = getScaledImage(width, height);
        return "".concat(url, "?width=").concat(scaledWidth, "&height=").concat(scaledHeight);
      }
    }
    return url;
  }
  return options.links.mediaFile.expand({
    imageId
  });
};
export const getAppName = tileData => {
  if (tileData._highlightResult) {
    const highlightedText = createTileHighlights(tileData._highlightResult, 'name', 'tokenizedName');
    return /*#__PURE__*/_jsx(AppTileHighlightedText, {
      highlightedText: highlightedText,
      originalText: tileData.name,
      overrideStyles: {
        color: "var(--ds-text, #172B4D)",
        fontWeight: 700
      }
    });
  }
  return tileData.name;
};
export const getTagLine = tileData => {
  if (tileData._highlightResult) {
    const highlightedText = createTileHighlights(tileData._highlightResult, 'tagLine', 'tokenizedTagLine');
    return /*#__PURE__*/_jsx(AppTileHighlightedText, {
      highlightedText: highlightedText,
      originalText: tileData.tagLine,
      overrideStyles: {
        color: "var(--ds-text, #172B4D)",
        fontWeight: 600
      }
    });
  }
  return tileData.tagLine;
};
export const createTileClickHandler = (tileData, onTileClick) => {
  return e => {
    e.stopPropagation();
    onTileClick === null || onTileClick === void 0 ? void 0 : onTileClick(tileData);
  };
};